import { latLngToCell } from "h3-js";

export function aggregateReportsByH3(reports, resolution, toCell = latLngToCell) {
  if (!Array.isArray(reports)) {
    throw new TypeError("Invalid reports input: expected an array of reports.");
  }
  const cells = new Map();
  reports.forEach((report, index) => {
    validateReport(report, index);
    const h3Index = toCell(report.latitude, report.longitude, resolution);
    const cell = cells.get(h3Index) || { h3Index, totalCount: 0, sickCount: 0 };
    cell.totalCount += 1;
    if (report.status === "sick") cell.sickCount += 1;
    cells.set(h3Index, cell);
  });
  return [...cells.values()]
    .sort((left, right) => left.h3Index.localeCompare(right.h3Index));
}

function validateReport(report, index) {
  const label = `report at index ${index}${report?.id ? ` (id ${report.id})` : ""}`;
  if (!report || typeof report !== "object") {
    throw new TypeError(`Invalid ${label}: expected an object.`);
  }
  validateCoordinate(report.latitude, "latitude", -90, 90, label);
  validateCoordinate(report.longitude, "longitude", -180, 180, label);
  if (report.status !== "sick" && report.status !== "healthy") {
    throw new TypeError(`Invalid ${label}: status must be "sick" or "healthy".`);
  }
}

function validateCoordinate(value, name, minimum, maximum, label) {
  if (!Number.isFinite(value)) {
    throw new TypeError(`Invalid ${label}: ${name} must be a finite number.`);
  }
  if (value < minimum || value > maximum) {
    throw new RangeError(`Invalid ${label}: ${name} must be between ${minimum} and ${maximum}.`);
  }
}
